import React, { useState, useEffect } from "react";
import { PrimljenePorukeDataTable } from "../components/PrimljenePorukeDataTable";
import { PoslanePorukeDataTable } from "../components/PoslanePorukeDataTable";
import UnauthorizedAccess from "../components/UnauthorizedAccess";
import InternalServerError from "../components/InternalServerError";

export const Poruke = (props) => {
  //const [restData, setRestData] = useState(null);
  const [primljenePoruke, setPrimljenePoruke] = useState([]);
  const [poslanePoruke, setPoslanePoruke] = useState([]);
  const [fetchState, setFetchState] = useState(null);

  useEffect(() => {
    setPrimljenePoruke([]);
    setPoslanePoruke([]);
    fetch(
      props.rest +
        sessionStorage.getItem("ustanova") +
        "&prema_obliku=" +
        sessionStorage.getItem("premaObliku") +
        "&godina_upisa=" +
        sessionStorage.getItem("godinaUpisa") +
        "&redni_broj=" +
        sessionStorage.getItem("redniBroj"),
      {
        method: "GET",
        mode: "cors",
        credentials: "include",
        headers: {
          Authorization: sessionStorage.getItem("token"),
          "Content-Type": "application/x-www-form-urlencoded",
        },
      }
    )
      .then((response) => {
        //console.log("Response poruke: " + response);
        if (response.status === 200) {
          setFetchState(200);
          return response.json();
        } else if (response.status === 204) {
          setFetchState(204);
          return null;
        } else if (response.status === 401) {
          setFetchState(401);
          return null;
        } else if (response.status === 500) {
          setFetchState(500);
          return null;
        } else {
          return null;
        }
      })
      .then((data) => {
        data.forEach( poruka => {
          if (poruka.posiljatelj_je_polaznik === true) {
            setPoslanePoruke(poslanePoruke => [...poslanePoruke, poruka]);
          } else {
            setPrimljenePoruke(primljenePoruke => [...primljenePoruke, poruka]);
          }
        })
      })
      .catch((err) => {
      });
  }, [props.rest]);

  return (
    <div>
        {fetchState === 200 ? (
            <><p className="page-title">Primljene poruke</p>
              <PrimljenePorukeDataTable data={primljenePoruke} rest={process.env.REACT_APP_PRODUCTION_ROOT_PATH + process.env.REACT_APP_PROCITAJ_PORUKU_PATH}/>{" "}
              <p className="page-title">Poslane poruke</p>
              <PoslanePorukeDataTable data={poslanePoruke} />
            </>
          ) : (
            ""
          )}
        {fetchState === 401 ? <UnauthorizedAccess /> : ""}
        {fetchState === 500 ? <InternalServerError /> : ""}
      </div>
  );
};

export default Poruke;
